/* 
  This controller is used to toggle the content type selector buttons
  and to dispatch an event when the content type is changed.

  The event is used to update the content type in the TomSelect controller
  and to reset the selected event content pieces.
*/

import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="content-type-selector"
export default class extends Controller {
  static targets = ['input', 'label']
  static values = { checked: String }
  
  connect() {
    const localType = localStorage.getItem('contentType')
    const contentTypes = this.inputTargets.map(input => input.value);
    const contentType = contentTypes.includes(localType) ? localType : this.checkedValue;
    
    this.selectCurrentRadioButton(contentType);
    this.tomSelectedElement = document.querySelector('[data-controller="tom-selected"]');
  }

  select(e) {
    this.toggleSelected(e);
  }

  toggleSelected(e) {
    this.resetAll();

    const contentType = e.target.value;
    
    this.selectCurrentRadioButton(contentType);
    localStorage.setItem('contentType', contentType);
    this.dispatchEvent(contentType);

    this.resetTomSelected(contentType);
  }

  selectCurrentRadioButton(contentType) {
    this.inputTargets.forEach((input) => {
      if (input.value === contentType) {
        input.closest('label').classList.add('selected');
        input.checked = true;
      }
    });
  }

  dispatchEvent(contentType) {
    const event = new CustomEvent('contentTypeChanged', { bubbles: true, detail: { contentType: contentType } });
    document.dispatchEvent(event);
  }
  
  resetTomSelected(contentType) {
    if (this.tomSelectedElement) {
      this.tomSelectedElement.tomselect.setValue('');
      if (contentType !== undefined) {
        localStorage.setItem('contentIds', '[]')
      }
    }
  }

  resetAll() {
    this.labelTargets.forEach(label => label.classList.remove('selected'));
    this.inputTargets.forEach(input => input.checked = false);
  }
}
